function getCookie(name, req) {
  if (process.server && req) {
    const cookies = req.headers.cookie || ''
    const match = cookies.match(new RegExp('(^|; )' + name + '=([^;]+)'))
    return match ? decodeURIComponent(match[2]) : null
  } else if (process.client) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
    return match ? decodeURIComponent(match[2]) : null
  }
  return null
}

export default async function ({ app, req }) {
  const $auth = app.$auth
  const $axios = app.$axios

  // Skip se auth non è inizializzato
  if (!$auth) {
    return
  }

  const authToken = getCookie('Authorization', req)
  console.log('[AutoLogin] loggedIn:', $auth.loggedIn, '| cookie:', authToken ? 'found' : 'not found')

  // Se non loggato ma cookie presente -> login
  if (!$auth.loggedIn && authToken) {
    try {
      console.log('[AutoLogin] Attempting login with token')
      await $auth.setUserToken(authToken)
      const response = await $axios.get('/proxyapi/auth/get-user-data')

      if (response.data) {
        $auth.setUser(response.data)
        console.log('[AutoLogin] Login successful')
        // Imposta locale utente
        if (response.data.locale) {
          app.i18n.setLocale(response.data.locale)
          app.$dayjs?.locale(response.data.locale)
        }
      }
    } catch (error) {
      // Token invalido - axios interceptor gestisce già 401/403/500
      console.error('[AutoLogin] Failed:', error.response?.status || error.message)
    }
  } else if ($auth.loggedIn && authToken) {
    // Sincronizza se il cookie Authorization è diverso dal token in auth._token.local
    const currentToken = $auth.strategy.token.get()
    if (currentToken !== authToken) {
      try {
        console.log('[AutoLogin] Token mismatch, syncing with Authorization cookie')
        await $auth.setUserToken(authToken)
        const response = await $axios.get('/proxyapi/auth/get-user-data')

        if (response.data) {
          $auth.setUser(response.data)
          console.log('[AutoLogin] Token sync successful')
          if (response.data.locale) {
            app.i18n.setLocale(response.data.locale)
            app.$dayjs?.locale(response.data.locale)
          }
        }
      } catch (error) {
        console.error('[AutoLogin] Token sync failed:', error.response?.status || error.message)
      }
    }
  }
}
